<div class="page">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
  @if (isLoading) {
    <div class="fullscreen-loader">
      <app-spinner [isLoading]="true" />
    </div>
  } @else {
    <div class="heading-wrapper">
      <div class="inline">
        <h4>
          {{ 'pages.serviceProcessing.title' | translate }}
          {{ formatDate(application?.visitDate || '') }},
          {{ application?.client?.name + ' ' + application?.client?.surname }}
        </h4>
        <p class="status" [ngClass]="[application?.backofficeStatus]">
          {{ 'pages.serviceProcessing.status.' + application?.backofficeStatus | translate }}
        </p>
        @if (application?.attendanceStatus !== attendenceStatuses.Unknown) {
          <div class="d-flex attendanceStatus">
            @if (application?.attendanceStatus === attendenceStatuses.Attended) {
              <img [attr.alt]="'imgAlt.attended.svg' | translate" src="assets/images/attended.svg" />
            } @else {
              <img [attr.alt]="'imgAlt.attended.svg' | translate" src="assets/images/notAttended.svg" />
            }
            <p class="attendence-status p-0 m-0">
              {{ 'pages.serviceProcessing.attendenceStatus.' + application?.attendanceStatus | translate }}
            </p>
          </div>
        }
      </div>
      @if (application?.attendanceStatus === attendenceStatuses.Unknown) {
        <div class="actions">
          @if (shouldRenderSubmitButton) {
            <app-multi-option-button
              [showArrowDownIcon]="true"
              [options]="filteredSubmitOptions"
              [text]="'pages.serviceProcessing.submit' | translate"
              (optionSelected)="onSubmitOptionSelected($event)" />
          }
          @if (shouldRenderStartProcessingButton) {
            <button class="secondary" (click)="startProcessing()">
              {{ 'pages.serviceProcessing.startProcessing' | translate }}
            </button>
          }
          @if (shouldRenderAttendencyButtons) {
            @if (shouldRenderAttendenceButton) {
              <button class="primary" (click)="setAttended()">
                {{ 'pages.serviceProcessing.attended' | translate }}
              </button>
              <button class="secondary" (click)="setUnattended()">
                {{ 'pages.serviceProcessing.unattended' | translate }}
              </button>
            }
          }
          @if (shouldRenderOherActionsButton) {
            <app-multi-option-button
              [showMenuIcon]="true"
              [options]="filteredActions"
              [text]="'pages.serviceProcessing.otherActions' | translate"
              (optionSelected)="onOtherActionsOptionSelected($event)"
              styleClass="secondary" />
          }
        </div>
      }
    </div>
    <div class="content-wrapper">
      <app-content-side-nav
        [activeItem]="activeItem"
        [navItems]="navItems"
        [navItemsCounts]="navItemsCounts"
        [unreadIcon]="[hasUnreadMessages ? 'processCommunication' : '']"
        [shouldTranslate]="true"
        (itemSelected)="activeItem = $event" />
      @if (activeItem === 'processApplication' && application) {
        <app-service-summary
          [application]="application"
          [attendenceStatus]="application.attendanceStatus"
          (messageSaved)="onMessageSaved($event)"
          (applicationUpdated)="onScheduleUpdated($event)" />
      } @else if (activeItem === 'processCommunication' && application) {
        <app-application-conversation
          [conversationList]="conversationList?.list ?? []"
          [application]="application"
          (markedAsRead)="checkUnreadMessages()"
          (messageSaved)="onMessageSaved($event)" />
      } @else if (activeItem === 'processHistory') {
        <app-reading-room-submission-versions [application]="application" [readingRoomSubmissionId]="application?.id" />
      } @else if (activeItem === 'processNotes') {
        <app-reading-room-submission-notes
          [application]="application!"
          [notes]="notes"
          [isSubmittingNoteFiles]="isSubmittingNoteFiles"
          (submissionNotesChanged)="onNoteChanged($event)" />
      }
    </div>
  }
</div>
@if (isChangeReadingRoomDialogOpen && application) {
  <app-change-reading-room-modal
    [isOpen]="isChangeReadingRoomDialogOpen"
    [application]="application"
    (close)="closeChangeReadingRoomDialog()"
    (cancel)="closeChangeReadingRoomDialog()"
    (update)="onChangeReadingRoom($event)" />
}
@if (isReassignUserDialogOpen && application) {
  <app-reassign-user-modal
    [isOpen]="isReassignUserDialogOpen"
    [application]="application"
    (close)="closeReassignUserDialog()"
    (cancel)="closeReassignUserDialog()"
    (update)="application = $event" />
}
<app-reject-submission-modal
  #rejectSubmissionModal
  [applicationId]="application?.id!"
  [isOpen]="isRejectSubmissionModalOpen"
  [application]="application"
  (confirm)="rejectSubmission($event)"
  (cancel)="isRejectSubmissionModalOpen = false" />
<app-cancel-submission-modal
  #cancelSubmissionModal
  [applicationId]="application?.id!"
  [isOpen]="isCancelSubmissionModalOpen"
  [application]="application"
  (confirm)="cancelSubmission($event)"
  (cancel)="isCancelSubmissionModalOpen = false" />

@if (application) {
  <app-request-additional-info-modal
    [isOpen]="isRequestAdditionalInfoModalOpen"
    [application]="application"
    [modalTitle]="'components.requestAdditionalNotes.requestTitle'"
    (cancel)="isRequestAdditionalInfoModalOpen = false"
    (update)="onRequestAdditionalInfo($event)" />
}

<app-approve-submission-modal #approveSubmissionModal [application]="application" (confirm)="approveSubmission($event)" />
